import * as moment from 'moment';

export enum DateFormatEnum {
  ddmmyy = 'DD-MM-YY',
  slashedddmmyy = 'DD/MM/YY',
  dateTime = 'DD MMMM YYYY - HH:mm',
  date = 'DD MMMM YYYY',
  year = 'YYYY',
  time = 'HH:mm',
  charDate = 'Do MMMM YYYY',
  dateFormat = 'DD MMMM YYYY',
  charDateTime = 'DD MMMM YYYY - HH:mm',
  charDateFormat = 'Do MMM YY',
  dateChar = 'DD MMM YYYY',
}

export function formatDate (date: string, format?: DateFormatEnum): string {
  if (!date) {
    return '';
  }
  return moment(date)
    .utc(false)
    .format(format || DateFormatEnum.date);
}

/*
    Converts UTC date to local date for it to be correctly displayed.
    This is important because some (if not all) UI components automatically convert any date to local date.
    For example, '09.04. 23:00:00 Z' would be displayed as '10.04. 02:00 EEST' in these components.
    Therefore, this function converts '09.04. 23:00:00 Z' to '09.04. 20:00:00 Z' for it to be displayed as '09.04. 23:00:00 EEST'
 */
export const convertUTCDateForDisplay = (date: Date): Date => {
  return moment(date).add(date.getTimezoneOffset(), 'minutes').toDate();
};

const toDate = (dateString: string) => {
  return new Date(dateString.replace(/-/g, '/').replace(/T.+/, ''));
};

export const convertUTCDateDisplay = (date: string): Date => {
  const dateArr = date.split('.');
  date = dateArr[0];
  const convertToDate = moment(date)
    .set({ hour: 0, minute: 0 })
    .format('YYYY-MM-DDTHH:mm:ss');
  return toDate(convertToDate);
};

export const castSelectedDateWithoutConversion = (
  selectedDate: Date,
  outputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
) => {
  selectedDate.setHours(0, 0, 0, 0);
  return moment(selectedDate).format(outputFormat);
};

export function NotificationTimeStamp (time) {
  const today = moment().endOf('day');
  const yesterday = moment().add(-1, 'day').endOf('day');
  const date = time && moment(time).endOf('day');
  const formattedDate = time && moment(time).format(`MMMM Do [at] HH:mm`);
  const isToday =
    date && date.toString() === today.toString()
      ? 'today' + moment(time).format(` [at] HH:mm`)
      : false;
  const isYesterday =
    date && date.toString() === yesterday.toString()
      ? 'yesterday' + moment(time).format(` [at] HH:mm`)
      : false;
  return isToday || isYesterday || formattedDate;
}
